// create const for each collection
const ENTERPRISES_COLLECTION = "enterprises";
const COLIS_COLLECTION = "colis";
const CLIENTS_COLLECTION = "clients";
const ADDRESS_COLLECTION = "address";
const DEPARTURES_COLLECTION = "departures";
const AGENCIES_COLLECTION = "agencies";
const USERS_COLLECTION = "users";
const PATHS_COLLECTION = "paths";
const TYPES_COLIS_COLLECTION = "types_colis";
const HYSTORY_COLLECTION = "history";

// exports all const
module.exports = {
  ENTERPRISES_COLLECTION,
  COLIS_COLLECTION,
  CLIENTS_COLLECTION,
  ADDRESS_COLLECTION,
  DEPARTURES_COLLECTION,
  AGENCIES_COLLECTION,
  USERS_COLLECTION,
  PATHS_COLLECTION,
  TYPES_COLIS_COLLECTION,
  HYSTORY_COLLECTION
}

